
export interface LASDataClassificationType {
    value: number | string;
    label: string;
}

let LASDataClassification: LASDataClassificationType[] = [
    { "value": 0, "label": "Never classified" },
    { "value": 1, "label": "Unassigned" },
    { "value": 2, "label": "Ground" },
    { "value": 3, "label": "Low Vegetation" },
    { "value": 4, "label": "Medium Vegetation" },
    { "value": 5, "label": "High Vegetation" },
    { "value": 6, "label": "Building" },
    { "value": 7, "label": "Low Point" },
    { "value": 8, "label": "Key Point" },
    { "value": 9, "label": "Water" },
    { "value": 10, "label": "Rail" },
    { "value": 11, "label": "Road Surface" },
    { "value": 12, "label": "Overlap" },
    { "value": 13, "label": "Wire - Guard(Shield)" },
    { "value": 14, "label": "Wire - Conductor(Phase)" },
    { "value": 15, "label": "Transmission Tower" },
    { "value": 16, "label": "Wire - Structure Connector(Insulator)" },
    { "value": 17, "label": "Bridge Deck" },
    { "value": 18, "label": "High Noise" }
]


export function getVisibleClasses() {
    const localStorageKey = 'classificationState';
    let storedState = localStorage.getItem(localStorageKey);
    if (!storedState) {
        storedState = JSON.stringify({ selectedItems: LASDataClassification, selectAll: true })
        localStorage.setItem(localStorageKey, storedState);
    }
    const { selectedItems } = JSON.parse(storedState);
    return selectedItems;
}

export { LASDataClassification }